import './CookiesPreferences.scss';
class CookiesPreferences {
    constructor( node ) {
        this.node = node;
        this.cookieLive = 7;
        this.cookieName = 'CookieConsent';
    }
    init() {
        let t = this;
        
        // -- set default -- //
            let arr = {};
            arr['wait_for_update'] = 2500;
            t.node.querySelectorAll('input[type="checkbox"]').forEach( function( input, index ) {
                input.getAttribute('name').split(',').forEach( function( key, index0 ) {
                    if( !arr[key.trim()] ) {
                        if( input.hasAttribute('disabled') ) {
                            arr[key.trim()] = 'granted';
                        } else {
                            arr[key.trim()] = 'denied';
                        }
                    }
                });
            });
            gtag('consent', 'default', arr );
        // -- END -- //

        let cookieVal = window.theme.methods.checkCookie('CookieConsent');
        if( cookieVal == '' ) {
            setTimeout( () => {
                t.node.classList.add('active');
                document.body.classList.add('disableScrollModal');
            }, 200 );
        } else {
            gtag( "consent", "update", JSON.parse( cookieVal) );
        }

        document.querySelectorAll('[href="#cookie_preferences"]').forEach( ( link, index ) => {
            link.addEventListener('click', ( event ) => {
                event.preventDefault();
                t.node.classList.add('active');
                document.body.classList.remove('disableScrollModal');
            });
        });
        if( window.location.hash && window.location.hash == '#cookie_preferences' ) {
            setTimeout(() => {
                t.node.classList.add('active');
                document.body.classList.remove('disableScrollModal');
            }, 200 );
        }

        let controls = t.node.querySelectorAll('.wrapper__control .item__button');
        let tabs = t.node.querySelectorAll('.wrapper__content .content__tab');

        // -- check other cookies -- //
            t.node.querySelectorAll('input[type="checkbox"]').forEach( ( input1, index1 ) => {
                input1.addEventListener('change', () => {

                    t.node.querySelectorAll('input[type="checkbox"][name="'+input1.getAttribute('name')+'"]').forEach( ( input2, index2 ) => {
                        if( input1.getAttribute('data-index') != input2.getAttribute('data-index') ) {
                            input2.checked = input1.checked;
                        }
                    });

                });
            });
        // -- END -- //

        // -- change tabs -- //
            controls.forEach( ( button, indexB ) => {
                button.addEventListener('click', () => {
                    tabs.forEach( ( tab, indexT ) => {
                        if( indexB != indexT ) {
                            tab.classList.remove('active');
                            controls[indexT].classList.remove('active');
                        } else {
                            tab.classList.add('active');
                            controls[indexT].classList.add('active');
                        }
                    });
                });
            });
        // -- END -- //

        // -- row buttons -- //
            t.node.querySelector('.wrapper__row button[data-action="reject"]').addEventListener('click', () => {
                let arr = {};
                t.node.querySelectorAll('input[type="checkbox"]').forEach( function( input, index ) {
                    input.getAttribute('name').split(',').forEach( function( key, index0 ) {
                        if( !input.hasAttribute('disabled') ) {
                            input.checked = false;
                        }
                        if( !arr[key.trim()] ) {
                            if( input.hasAttribute('disabled') ) {
                                arr[key.trim()] = 'granted';
                            } else {
                                arr[key.trim()] = 'denied';
                            }
                        }
                    });
                });
                if( arr ) {
                    gtag( "consent", "update", arr );
                    window.theme.methods.setCookie( t.cookieName , JSON.stringify( arr ), t.cookieLive );
                }
                t.setPoliciesPR();
                t.node.classList.remove('active');
                document.body.classList.remove('disableScrollModal');
            });

            if( t.node.querySelector('.wrapper__row button[data-action-tab]') ) {
                t.node.querySelector('.wrapper__row button[data-action-tab]').addEventListener('click', ( event ) => {
                    controls.forEach( ( button, indexB ) => {
                        if( indexB != parseInt( event.target.getAttribute('data-action-tab') ) ) {
                            button.classList.remove('active');
                            tabs[ indexB ].classList.remove('active');
                        } else {
                            button.classList.add('active');
                            tabs[ indexB ].classList.add('active');
                        }
                    });
                });
            }

            t.node.querySelector('.wrapper__row button[data-action="accept"]').addEventListener('click', () => {
                let arr = {};
                t.node.querySelectorAll('input[type="checkbox"]').forEach( function( input, index ) {
                    input.getAttribute('name').split(',').forEach( function( key, index0 ) {
                        if( !arr[key.trim()] ) {
                            if( input.checked ) {
                                arr[key.trim()] = 'granted';
                            } else {
                                arr[key.trim()] = 'denied';
                            }
                        }
                    });
                });
                if( arr ) {
                    gtag( "consent", "update", arr );
                    window.theme.methods.setCookie( t.cookieName , JSON.stringify( arr ), t.cookieLive );
                }
                t.setPoliciesPR();
                t.node.classList.remove('active');
                document.body.classList.remove('disableScrollModal');
            });
        // -- END -- //

        t.setPoliciesPR();

    }
    setPoliciesPR() { // set policies for profit room
        let t = this;
        let value = window.theme.methods.checkCookie( t.cookieName );
        let permissions = [];
        if( value ) {
            value = JSON.parse( value );

            permissions.push( 'necessary' );
            permissions.push( 'security_storage' );
            if( value['functionality_storage'] == 'granted' ) {
                permissions.push( 'functionality_storage' );
            }
            if( value['ad_storage'] == 'granted' ) {
                permissions.push( 'marketing' );
                permissions.push( 'ad_storage' );
                permissions.push( 'personalization_storage' );
            }
            if( value['analytics_storage'] == 'granted' ) {
                permissions.push( 'analytics' );
                permissions.push( 'analytics_storage' );
            }
            if( permissions ) {
                window.beAcceptedCookiePolicies = permissions;
            }

        }
    }
}
JSModules['CookiesPreferences'] = CookiesPreferences;
export default CookiesPreferences;